import React from 'react';
import { GradientLogo } from '@wave-engagement/wave-react';
import { Button } from '../../../components';
import { Link } from 'react-router-dom';

const Welcome = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      {/* Logo */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3em' }}>
        <img src={GradientLogo} alt='Wave Engagement Logo' style={{ width: '100%', maxWidth: '300px', objectFit: 'contain', marginTop: '3em' }} />
      </div>

      {/* Buttons */}
      <Button fullWidth component={Link} to='/auth/create-account'>I'm New</Button>
      <Button fullWidth style={{ marginTop: '10px' }} component={Link} to='/auth/login'>Login</Button>
    </div>
  );
}
export default Welcome;